// dependencies
import React from "react";

import Spinner from "../../../../../../components/Spinner";
// components
import Text from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";

// store
import useStore from "../../../../store";

// hooks
import { useQuestionCompletionKPI } from "../../../../../../api/hooks";

import Config from "../../../../Config";
import QuestionsKPIBarChart from "../QuestionsKPIBarChart";
//css
import css from "../shared.module.scss";

const QuestionCompletionKPI = () => {
	// setup
	const [filter] = useStore((state) => [state.filter]);
	const binSize = Config.BIN_SIZE;

	const { data, isLoading } = useQuestionCompletionKPI({
		startDate: filter.startDate,
		endDate: filter.endDate,
		binSize,
	});

	const questionsCompletionData = data?.data || null;

	const percentage = questionsCompletionData?.question_answered_rate || 0;
	const monthlyData =
		questionsCompletionData?.monthly_averages.map((data) => ({
			time_bucket: data.time_bucket,
			average: data.average,
		})) || [];

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="regular">
							Questions{" "}
							<Text element="span" size="paragraph-2" weight="semi-bold">
								Answered
							</Text>
						</Text>
					</span>
				}
				info="This chart displays the question response rate of all surveys during the selected period."
			/>
			<CardBody>
				{isLoading && (
					<div className={css.spinner}>
						<Spinner />
					</div>
				)}
				{!isLoading && (
					<div className={css.cardBody}>
						<div className={css.leftContent}>
							<p className={css.largeText}>{percentage}%</p>
							<Text size="caption" weight="semi-bold" className={css.subText}>
								Questions Answered
							</Text>
						</div>
						<div className={css.barChart}>
							<QuestionsKPIBarChart monthlyData={monthlyData} />
						</div>
					</div>
				)}
			</CardBody>
		</>
	);
};

export default QuestionCompletionKPI;
